module.exports = __webpack_public_path__ + "img/shutterstock_244190287.518294cd.png";